<template>
    <div id="description" :style="`color: ${theme.copy}`" v-html="description"></div>
</template>

<script>
export default {
    name: "ProjectDescription",
    props: {
        theme: Object,
        description: String
    }
};
</script>